import { SET_GEOCODE_CUSTOMER_ADDRESS } from "constants-lib/actionTypes"

export const setGeocodeCustomerAddress = (data) => ({
  type: SET_GEOCODE_CUSTOMER_ADDRESS,
  payload: data,
})
